import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'WarningAlert'
})
export default class WarningAlert extends Vue {
    @Prop({ required: true })
    message!: string;
}